enum PortalType {
  Borrower = 'borrower',
  Intermediary = 'intermediary',
}

export default PortalType;
